var _style, _rect, _polygon, _polygon2, _path, _path2, _path3, _path4, _path5, _polygon3, _polygon4, _rect2, _g, _path6, _path7, _path8, _polygon5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrandDna(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "443px",
    height: "101px",
    viewBox: "0 0 443 101",
    style: {
      enableBackground: "new 0 0 443 101"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8.5,
    className: "st0",
    width: 425.2,
    height: 85
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "130.9,35.2 135.8,35.2 151.9,66.5 147,66.5 143,58.5 123.6,58.5 119.6,66.5 114.8,66.5 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "141.1,54.6 133.4,39.1 125.7,54.6 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.1,35.2h18c4.8,0,12.3,1.1,12.3,8.9c0,6.3-5.7,8.3-9.4,8.6L108,66.4h-5.2L93,52.8H81.3v13.6h-4.2V35.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.3,49.1h12.9c5.5,0,9.1-0.8,9.1-5c0-4.2-3.7-5-9.1-5H81.3V49.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.1,66.2V35.5h17.7c3.5,0,11.9,0,11.9,8c0,4.2-2.7,5.5-4.7,6.4c1.8,0.8,5.7,2.5,5.7,7.6c0,8.2-8.7,8.6-15,8.6 H36.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.8,51.7v11.2h14.4c4.5,0,8.9-0.8,8.9-5.5c0-4.3-3.4-5.7-8.4-5.7H39.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.8,38.6v9.9h13c4.4,0,9.2-0.7,9.2-5c0-4.9-5-4.9-10.4-4.9H39.8z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "372.3,34 388.1,66.5 379.1,66.5 376.2,60.1 358.7,60.1 355.7,66.5 346.7,66.5 362.7,34 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "367.5,41.5 362.3,52.5 372.7,52.5 "
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 396.1,
    y: 35.4,
    className: "st1",
    width: 8.7,
    height: 8.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M311.8,34l20.6,22.1V34h7.1v32.5h-7l-21.4-23v23h-7.2V34L311.8,34L311.8,34z M259.9,66.5V34h15.7 c10.3,0,18.5,4.3,18.5,16c0,11.1-7.6,16.5-18.3,16.5H259.9L259.9,66.5z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M266.3,61h6.5c10.8,0,15-3.3,15-10.9c0-8-4.4-10.7-15-10.7h-6.5V61z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M202.4,34.5h16.1c9.9,0,17.3,5.3,17.3,16c0,13.3-10.2,16.6-18.5,16.6h-14.9V34.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.1,61.9h9.8c3.1,0,12.3-0.4,12.3-11.5c0-8.2-5.7-10.7-11.7-10.7h-10.4V61.9z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "159.2,34.8 165.4,34.8 187.3,59 187.3,34.8 192.3,34.8 192.3,66.8 187.6,66.8 164,40.5 164,66.8  159.2,66.8 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandDna);
export default __webpack_public_path__ + "static/media/brand-dna.d6b5a27dc8dd2b58f8d586a4fb4377d2.svg";
export { ForwardRef as ReactComponent };